/**
 * section-main-product.js
 * ────────────────────────────────────────────────────────────
 * OS 2.0 product section JS.
 * Handles: variant selection, AJAX ATC, quantity stepper,
 * gallery thumbnails, zoom lightbox, description toggle,
 * FBT, share button, sticky bar.
 * ────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  document.querySelectorAll('[data-main-product]').forEach(function (section) {
    var sectionId = section.dataset.sectionId;

    /* ══════════════════════════════════════════════════════
       PRODUCT DATA
       ══════════════════════════════════════════════════════ */
    var productDataEl = $('[data-product-json]', section);
    var productData   = productDataEl ? JSON.parse(productDataEl.textContent) : null;
    var variants      = productData ? productData.variants : [];

    /* ══════════════════════════════════════════════════════
       VARIANT SELECTOR
       ══════════════════════════════════════════════════════ */
    var variantSelects  = $$('[data-variant-select]', section);
    var variantIdInput  = $('[data-variant-id]', section);
    var priceEl         = $('[data-product-price]', section);
    var comparePriceEl  = $('[data-compare-price]', section);
    var saveBadgeEl     = $('[data-save-badge]', section);
    var atcButton       = $('[data-atc-button]', section);
    var atcText         = $('[data-atc-text]', section);
    var stickyPriceEl   = $('[data-sticky-price]', section);
    var stickyAtcEl     = $('[data-sticky-atc]', section);
    var productForm     = $('[data-product-form]', section);
    var galleryGoTo     = null; /* set by gallery controller IIFE */

    /* Buy Buttons block setting — when true, displayed price multiplies
       by the quantity stepper. Cart still receives the correct line total
       regardless; this only controls the on-page display. */
    var calcByQty = !!(productForm && productForm.dataset.calcByQty === 'true');
    var currentUnitPrice = parseInt(productForm && productForm.dataset.unitPrice, 10) || 0;

    function getSelectedOptions() {
      return variantSelects.map(function (sel) { return sel.value; });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      }) || null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    /* Re-renders every price-display element (price block, ATC button text,
       sticky bar) using currentUnitPrice — multiplied by the qty stepper
       when calcByQty is on. Skips ATC button if it's currently disabled
       (sold-out / unavailable) so we don't overwrite the "Sold Out" label. */
    function readQty() {
      var qtyEl = $('[data-qty-input]', section);
      return qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    }
    function recalcPriceDisplay() {
      var multiplier = calcByQty ? readQty() : 1;
      var total = currentUnitPrice * multiplier;
      var formatted = formatMoney(total);
      // if (priceEl)       priceEl.textContent       = formatted;
      if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      if (atcButton && atcText && !atcButton.disabled) {
        var label = atcButton.dataset.atcLabel || 'Add to cart';
        atcText.textContent = label + ' — ' + formatted;
      }
    }

    function updateForVariant(variant) {
      if (!variant) return;

      /* hidden id input */
      if (variantIdInput) variantIdInput.value = variant.id;

      /* unit-price snapshot — recalcPriceDisplay reads this each render */
      currentUnitPrice = variant.price;
      if (productForm) productForm.dataset.unitPrice = variant.price;

      /* compare / save badge */
      if (comparePriceEl && saveBadgeEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
          comparePriceEl.removeAttribute('hidden');
          saveBadgeEl.textContent = 'Save ' + pct + '%';
          saveBadgeEl.style.display = '';
          saveBadgeEl.removeAttribute('hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.style.display = 'none';
          saveBadgeEl.textContent = '';
          saveBadgeEl.style.display = 'none';
        }
      }
      if(priceEl){
        priceEl.textContent = formatMoney(variant.price);
      }
      

      /* ATC button availability state \u2014 text is set by recalcPriceDisplay */
      if (atcButton && atcText) {
        if (variant.available) {
          atcButton.disabled = false;
        } else {
          atcButton.disabled = true;
          atcText.textContent = 'Sold Out';
        }
      }

      if (stickyAtcEl) stickyAtcEl.disabled = !variant.available;

      /* Now that unit price + button state are set, refresh every display */
      recalcPriceDisplay();

      /* gallery image swap — navigate to the matching slide */
      if (variant.featured_image && galleryGoTo) {
        var targetMediaId = String(variant.featured_image.id);
        var allSlides = section.querySelectorAll('[data-gallery-slide]');
        var targetIdx = -1;
        allSlides.forEach(function (sl, i) {
          if (sl.dataset.mediaId === targetMediaId) targetIdx = i;
        });
        if (targetIdx >= 0) galleryGoTo(targetIdx);
      }

      /* update URL without reload */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (variantSelects.length) {
      variantSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var v = findVariant(getSelectedOptions());
          updateForVariant(v);
        });
      });
    }

    /* ══════════════════════════════════════════════════════
       QUANTITY STEPPER
       ══════════════════════════════════════════════════════ */
    var qtyInput = $('[data-qty-input]', section);
    var qtyMinus = $('[data-qty-minus]', section);
    var qtyPlus  = $('[data-qty-plus]', section);

    if (qtyInput) {
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
          recalcPriceDisplay();
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = v + 1;
          recalcPriceDisplay();
        });
      }
      qtyInput.addEventListener('input',  recalcPriceDisplay);
      qtyInput.addEventListener('change', recalcPriceDisplay);
    }

    /* ══════════════════════════════════════════════════════
       AJAX ADD-TO-CART
       ══════════════════════════════════════════════════════ */
    var productForm = $('[data-product-form]', section);

    if (productForm && atcButton && atcText) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcButton.disabled) return;

        var formData = new FormData(productForm);
        var id       = parseInt(formData.get('id'), 10);
        var qty      = parseInt(formData.get('quantity') || '1', 10);

        atcButton.classList.add('is-loading');
        atcButton.disabled = true;
        var prevText = atcText.textContent;
        atcText.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw d; });
            return r.json();
          })
          .then(function () {
            atcText.textContent = 'Added!';
            openCart();
            setTimeout(function () {
              atcButton.classList.remove('is-loading');
              atcButton.disabled = false;
              atcText.textContent = prevText;
            }, 1500);
          })
          .catch(function (err) {
            atcButton.classList.remove('is-loading');
            atcButton.disabled = false;
            atcText.textContent = (err && err.description) ? err.description : 'Error \u2014 try again';
            setTimeout(function () { atcText.textContent = prevText; }, 2500);
            /* error already surfaced to user via button text */
          });
      });
    }

    /* ══════════════════════════════════════════════════════
       GALLERY — Main slider + thumbnail sync + drag/swipe
       ══════════════════════════════════════════════════════ */
    var thumbs = $$('[data-gallery-thumb]', section);

    /* ── Thumbnail strip arrows (keep existing logic, add scroll sync) ── */
    (function () {
      var wrap     = $('[data-thumbs-wrap]', section);
      if (!wrap) return;
      var thumbsEl = $('[data-gallery-thumbs]', wrap);
      var btnPrev  = $('[data-thumb-prev]', wrap);
      var btnNext  = $('[data-thumb-next]', wrap);
      var count    = parseInt(wrap.dataset.thumbCount, 10) || 0;
      if (!thumbsEl || !btnPrev || !btnNext || count === 0) return;

      var galleryEl = wrap.closest('.product-gallery');
      var DESKTOP_THRESHOLD = parseInt(wrap.dataset.visibleCount, 10) || 6;
      var MOBILE_THRESHOLD = 4, MOBILE_BP = 810, GAP = 8;
      var scrollPos = 0;

      function isMobile() { return window.innerWidth <= MOBILE_BP; }
      function isHoriz() {
        return isMobile() || (galleryEl && galleryEl.classList.contains('product-gallery--horizontal'));
      }
      function stepSize() {
        var f = thumbsEl.querySelector('.product-gallery__thumb');
        return f ? (isHoriz() ? f.offsetWidth : f.offsetHeight) + GAP : 72;
      }
      function maxScroll() {
        return isHoriz()
          ? thumbsEl.scrollWidth - thumbsEl.clientWidth
          : thumbsEl.scrollHeight - thumbsEl.clientHeight;
      }
      function applyScroll(pos) {
        scrollPos = Math.max(0, Math.min(pos, maxScroll()));
        if (isHoriz()) thumbsEl.scrollLeft = scrollPos;
        else           thumbsEl.scrollTop  = scrollPos;
        updateArrows();
      }
      function updateArrows() {
        btnPrev.disabled = scrollPos <= 0;
        btnNext.disabled = scrollPos >= maxScroll() - 1;
      }
      function activate() {
        var mobile = isMobile(), horiz = isHoriz();
        var needed = count > (mobile ? MOBILE_THRESHOLD : DESKTOP_THRESHOLD);
        if (needed) {
          btnPrev.removeAttribute('hidden'); btnNext.removeAttribute('hidden');
          thumbsEl.style[horiz ? 'overflowX' : 'overflowY'] = 'hidden';
          thumbsEl.style[horiz ? 'overflowY' : 'overflowX'] = '';
          scrollPos = 0; updateArrows();
        } else {
          btnPrev.setAttribute('hidden', ''); btnNext.setAttribute('hidden', '');
          thumbsEl.style[horiz ? 'overflowX' : 'overflowY'] = 'auto';
          thumbsEl.style[horiz ? 'overflowY' : 'overflowX'] = '';
        }
      }

      btnPrev.addEventListener('click', function () { applyScroll(scrollPos - stepSize()); });
      btnNext.addEventListener('click', function () { applyScroll(scrollPos + stepSize()); });

      /* Keep scrollPos in sync regardless of how thumbsEl was scrolled */
      thumbsEl.addEventListener('scroll', function () {
        scrollPos = isHoriz() ? thumbsEl.scrollLeft : thumbsEl.scrollTop;
        updateArrows();
      }, { passive: true });

      activate();
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt); rt = setTimeout(function () {
          scrollPos = 0; thumbsEl.scrollTop = 0; thumbsEl.scrollLeft = 0; activate();
        }, 150);
      }, { passive: true });

      /* Expose scroll helper for gallery controller to call */
      wrap._scrollThumbIntoView = function (thumb) {
        requestAnimationFrame(function () {
          var horiz = isHoriz();
          if (horiz) {
            var l = thumb.offsetLeft - thumbsEl.offsetLeft;
            var r = l + thumb.offsetWidth;
            if (l < scrollPos) applyScroll(l);
            else if (r > scrollPos + thumbsEl.clientWidth) applyScroll(r - thumbsEl.clientWidth);
          } else {
            var t = thumb.offsetTop - thumbsEl.offsetTop;
            var b = t + thumb.offsetHeight;
            if (t < scrollPos) applyScroll(t);
            else if (b > scrollPos + thumbsEl.clientHeight) applyScroll(b - thumbsEl.clientHeight);
          }
        });
      };
    })();

    /* ── Main gallery slider controller ── */
    (function () {
      var galleryMain = $('[data-gallery-main]', section);
      if (!galleryMain) return;

      var track      = $('[data-gallery-track]', galleryMain);
      var slides     = $$('[data-gallery-slide]', galleryMain);
      var prevBtn    = $('[data-gallery-prev]', galleryMain);
      var nextBtn    = $('[data-gallery-next]', galleryMain);
      var total      = slides.length;
      var current    = 0;
      var thumbsWrap = $('[data-thumbs-wrap]', section);

      if (!track || total === 0) return;

      /* ── Infinite loop: clone first + last slides ──────────────
         DOM layout after cloning:
           [lastClone] [slide0] [slide1] … [slideN-1] [firstClone]
         Real slide i → DOM position i + 1.
         Clones have no data-gallery-slide so they don't interfere
         with slide queries or the lightbox. ─────────────────────── */
      var domOffset = 0;
      if (total > 1) {
        var firstClone = slides[0].cloneNode(true);
        var lastClone  = slides[total - 1].cloneNode(true);
        firstClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('aria-hidden',  'true');
        firstClone.removeAttribute('data-gallery-slide');
        lastClone.removeAttribute('data-gallery-slide');
        track.appendChild(firstClone);
        track.insertBefore(lastClone, track.firstChild);
        domOffset = 1;
      }

      var snapping = false; // guard: prevents stacked transitionend listeners

      /* ─ Update active-slide state + thumbnails ─ */
      function updateState(idx) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === idx);
          if (i !== idx) {
            var vid = slide.querySelector('[data-gallery-video]');
            if (vid) { vid.pause(); }
          }
        });
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
        var activeSlide = slides[idx];
        var mediaId = activeSlide ? activeSlide.dataset.mediaId : null;
        thumbs.forEach(function (thumb) {
          var match = mediaId && thumb.dataset.mediaId === mediaId;
          thumb.classList.toggle('is-active', match);
          if (match && thumbsWrap && thumbsWrap._scrollThumbIntoView) {
            thumbsWrap._scrollThumbIntoView(thumb);
          }
        });
      }

      /* ─ Core navigate function ─
         Boundary cases (idx < 0 or idx >= total) animate into the
         clone, then instantly snap to the real counterpart slide —
         giving a seamless infinite loop in the correct direction. */
      function goTo(idx, instant) {
        if (total <= 1) { updateState(0); return; }

        if (!instant && idx >= total) {
          /* Forward past last → slide into firstClone (DOM pos total+1),
             then snap instantly back to real slide 0 (DOM pos 1). */
          track.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)';
          track.style.transform  = 'translateX(-' + ((total + 1) * 100) + '%)';
          current = 0;
          updateState(0);
          if (!snapping) {
            snapping = true;
            track.addEventListener('transitionend', function onFwd() {
              track.removeEventListener('transitionend', onFwd);
              snapping = false;
              goTo(0, true);
            });
          }
          return;
        }

        if (!instant && idx < 0) {
          /* Backward past first → slide into lastClone (DOM pos 0),
             then snap instantly back to real slide total-1 (DOM pos total). */
          track.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)';
          track.style.transform  = 'translateX(0%)';
          current = total - 1;
          updateState(total - 1);
          if (!snapping) {
            snapping = true;
            track.addEventListener('transitionend', function onBwd() {
              track.removeEventListener('transitionend', onBwd);
              snapping = false;
              goTo(total - 1, true);
            });
          }
          return;
        }

        /* Normal range or instant snap-back after clone animation */
        idx = ((idx % total) + total) % total;
        current = idx;
        var domPos = idx + domOffset;

        track.style.transition = instant
          ? 'none'
          : 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)';
        track.style.transform = 'translateX(-' + (domPos * 100) + '%)';
        if (instant) track.offsetHeight; /* force reflow so next animation starts cleanly */

        updateState(idx);
      }

      /* Expose for external callers (variant swap) */
      galleryGoTo = goTo;

      /* ─ Thumbnail clicks → navigate main slider ─ */
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var mediaId = thumb.dataset.mediaId;
          var idx = -1;
          slides.forEach(function (slide, i) {
            if (slide.dataset.mediaId === mediaId) idx = i;
          });
          if (idx >= 0) goTo(idx);
        });
      });

      /* ─ Arrow buttons ─ */
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      /* ─ Keyboard navigation ─ */
      galleryMain.setAttribute('tabindex', '0');
      galleryMain.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });

      /* ─ Drag / swipe (pointer events with axis locking) ─ */
      var dragStartX = 0, dragStartY = 0;
      var dragging = false, lockAxis = null, dragDx = 0;
      var SWIPE_THRESHOLD = 50, LOCK_THRESHOLD = 8;

      galleryMain.addEventListener('pointerdown', function (e) {
        /* Ignore right-click on mouse */
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        /* Don't start drag on buttons */
        if (e.target.closest('button')) return;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragging   = true;
        lockAxis   = null;
        dragDx     = 0;
        galleryMain.setPointerCapture(e.pointerId);
      }, { passive: true });

      galleryMain.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;

        /* Determine axis lock on first significant move */
        if (!lockAxis && (Math.abs(dx) > LOCK_THRESHOLD || Math.abs(dy) > LOCK_THRESHOLD)) {
          lockAxis = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
        }

        if (lockAxis !== 'h') return;

        /* Prevent page scroll when dragging horizontally */
        e.preventDefault();

        dragDx = dx;
        track.classList.add('is-dragging');
        track.style.transition = 'none';
        /* Use (current + domOffset) so drag starts from the correct clone-aware position */
        track.style.transform  = 'translateX(calc(' + (-((current + domOffset) * 100)) + '% + ' + dragDx + 'px))';
      });

      galleryMain.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');

        if (lockAxis !== 'h') { lockAxis = null; return; }
        lockAxis = null;

        if (Math.abs(dragDx) >= SWIPE_THRESHOLD) {
          goTo(dragDx < 0 ? current + 1 : current - 1);
        } else {
          goTo(current); /* snap back */
        }
      }, { passive: true });

      galleryMain.addEventListener('pointercancel', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        lockAxis = null;
        goTo(current);
      }, { passive: true });

      /* Prevent native image drag interfering */
      galleryMain.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* Initialise at real slide 0 (DOM position 1 with clones) */
      goTo(0, true);
    })();

    /* ══════════════════════════════════════════════════════
       ZOOM LIGHTBOX
       ══════════════════════════════════════════════════════ */
    var zoomTrigger = $('[data-zoom-trigger]', section);
    var lightbox    = document.getElementById('mp-lightbox-' + sectionId);
    var lbImg       = lightbox ? $('[data-lightbox-img]', lightbox) : null;
    var lbClose     = lightbox ? $('[data-lightbox-close]', lightbox) : null;
    var lbPrev      = lightbox ? $('[data-lightbox-prev]', lightbox) : null;
    var lbNext      = lightbox ? $('[data-lightbox-next]', lightbox) : null;
    var lbIndex     = 0;
    /* If you want to enable the magnifier on mobile, un-comment the
       next line (it is set by the mobile lightbox controller further
       down, which is also commented out): */
    /* var lbMobileReset = null; */

    function getLBImages() {
      /* Anchor to [data-gallery-slide] (real slides only). The infinite-loop
         clones keep the .product-gallery__slide class and a deep-copied inner
         [data-gallery-slide-img], but have data-gallery-slide stripped — so
         scoping by class would count the clones twice and surface duplicate
         images at the end of the lightbox. */
      return Array.prototype.slice.call(
        section.querySelectorAll('[data-gallery-slide] [data-gallery-slide-img]')
      );
    }

    function showLBAt(idx) {
      var imgs = getLBImages();
      if (!imgs.length || !lbImg) return;
      lbIndex = (idx + imgs.length) % imgs.length;
      var img = imgs[lbIndex];
      lbImg.src = (img.dataset && img.dataset.zoomSrc) ? img.dataset.zoomSrc : img.src;
      lbImg.alt = img.alt || '';
      var hasMultiple = imgs.length > 1;
      if (lbPrev) lbPrev.hidden = !hasMultiple;
      if (lbNext) lbNext.hidden = !hasMultiple;
      /* If you want to enable the magnifier on mobile, un-comment: */
      /* if (lbMobileReset) lbMobileReset(); */ /* re-fit viewer for new image */
    }

    function openLB() {
      if (!lightbox || !lbImg) return;
      var imgs = getLBImages();
      var startIdx = 0;
      var activeSlide = section.querySelector('[data-gallery-slide].is-active');
      if (activeSlide) {
        var activeImg = activeSlide.querySelector('[data-gallery-slide-img]');
        if (activeImg) {
          var found = imgs.indexOf(activeImg);
          if (found !== -1) startIdx = found;
        }
      }
      showLBAt(startIdx);
      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        lightbox.classList.add('is-open');
        /* If you want to enable the magnifier on mobile, un-comment the
           next line (fits the mobile viewer once the lightbox has layout): */
        /* if (lbMobileReset) lbMobileReset(); */
      });
    }

    function closeLB() {
      if (!lightbox) return;
      /* Sync the main slider to the slide the user landed on inside the
         lightbox. getLBImages() and the gallery's slides[] array both anchor
         on [data-gallery-slide] (real slides, no clones), so lbIndex maps
         1:1 to the main gallery slide index. */
      if (galleryGoTo) galleryGoTo(lbIndex);
      /* If you want to enable the magnifier on mobile, un-comment this
         block (leaves browser full-screen if the viewer entered it): */
      /*
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (fsEl) {
        (document.exitFullscreen || document.webkitExitFullscreen || function () {}).call(document);
      }
      */
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      lightbox.addEventListener('transitionend', function h() {
        lightbox.setAttribute('hidden', '');
        lightbox.removeEventListener('transitionend', h);
      });
    }

    if (zoomTrigger) zoomTrigger.addEventListener('click', openLB);
    if (lbClose)     lbClose.addEventListener('click', closeLB);
    if (lbPrev)      lbPrev.addEventListener('click', function () { showLBAt(lbIndex - 1); });
    if (lbNext)      lbNext.addEventListener('click', function () { showLBAt(lbIndex + 1); });
    if (lightbox)    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLB(); });
    document.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hasAttribute('hidden')) return;
      if (e.key === 'Escape')      closeLB();
      if (e.key === 'ArrowLeft')   showLBAt(lbIndex - 1);
      if (e.key === 'ArrowRight')  showLBAt(lbIndex + 1);
    });

    /* If you want to enable the magnifier (full-screen pan + zoom) on
       mobile (<810px), un-comment the entire block below, AND un-comment:
         • the `lbMobileReset` declaration and its two call sites + the
           full-screen exit in closeLB (all marked above), and
         • the matching markup in sections/main-product.liquid, and
         • the matching CSS block in assets/section-main-product.css.
       Disabled by default; on ≥810px the lightbox is unaffected. */
//     /* ══════════════════════════════════════════════════════
//        MOBILE LIGHTBOX  ( < 810px )  — pan + zoom + fullscreen
//        ──────────────────────────────────────────────────────
//        On narrow screens the lightbox becomes a full-screen
//        image viewer: drag to pan, pinch / double-tap / buttons
//        to zoom, and a button to enter browser full-screen.
//        On ≥810px none of this runs and the lightbox keeps its
//        original behaviour. The image transform is only touched
//        while the small-screen viewer is active. */
//     (function setupMobileLightbox() {
//       if (!lightbox || !lbImg) return;
//       var stage      = $('[data-lightbox-stage]', lightbox);
//       var controls   = $('[data-lightbox-controls]', lightbox);
//       var zoomInBtn  = $('[data-lightbox-zoomin]', lightbox);
//       var zoomOutBtn = $('[data-lightbox-zoomout]', lightbox);
//       var fsBtn      = $('[data-lightbox-fullscreen]', lightbox);
//       if (!stage) return;
// 
//       var MOBILE_MQ = window.matchMedia('(max-width: 809.98px)');
//       var MIN_SCALE = 1;
//       var MAX_SCALE = 4;
// 
//       /* The <img> fills the stage (width/height:100%, object-fit:contain),
//          so its ELEMENT box == the stage and the visible image is the
//          object-fit "content box" centred inside it. The base transform
//          (scale 1, no translate) is therefore already fitted & centred —
//          we only layer translate+scale on top for pan/zoom.
//          transform-origin is 0 0. */
//       var scale = 1, tx = 0, ty = 0;
// 
//       function isMobile() { return MOBILE_MQ.matches; }
// 
//       function apply(animate) {
//         lbImg.classList.toggle('is-animating', !!animate);
//         lbImg.style.transform =
//           'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
//       }
// 
//       /* object-fit:contain content box within the (vw×vh) element box.
//          Returns {ox,oy,cw,ch}: offset + content size at scale 1. */
//       function contentBox() {
//         var vw = stage.clientWidth || 1;
//         var vh = stage.clientHeight || 1;
//         var natW = lbImg.naturalWidth  || vw;
//         var natH = lbImg.naturalHeight || vh;
//         var fit = Math.min(vw / natW, vh / natH);
//         var cw = natW * fit;
//         var ch = natH * fit;
//         return { ox: (vw - cw) / 2, oy: (vh - ch) / 2, cw: cw, ch: ch };
//       }
// 
//       /* Keep the displayed image edges glued to (or centred within) the
//          viewport — no empty gutters once zoomed past fit. */
//       function clamp() {
//         var vw = stage.clientWidth;
//         var vh = stage.clientHeight;
//         var b = contentBox();
//         var dispW = b.cw * scale;
//         var dispH = b.ch * scale;
// 
//         if (dispW <= vw) {
//           tx = (vw - dispW) / 2 - b.ox * scale;       // centre
//         } else {
//           var minX = vw - (b.ox + b.cw) * scale;       // right edge ≥ vw
//           var maxX = -b.ox * scale;                    // left edge ≤ 0
//           tx = Math.max(minX, Math.min(tx, maxX));
//         }
//         if (dispH <= vh) {
//           ty = (vh - dispH) / 2 - b.oy * scale;        // centre
//         } else {
//           var minY = vh - (b.oy + b.ch) * scale;
//           var maxY = -b.oy * scale;
//           ty = Math.max(minY, Math.min(ty, maxY));
//         }
//       }
// 
//       /* Zoom level the viewer opens at. The image starts zoomed in
//          (same level as a double-tap) and centred; the user can pinch /
//          double-tap / press − to zoom back out, and drag to pan. */
//       var INITIAL_SCALE = 2.5;
// 
//       /* Reset to the opening view: fitted base, then zoomed to
//          INITIAL_SCALE about the centre. */
//       function resetView() {
//         scale = 1; tx = 0; ty = 0;          // fitted, centred base
//         zoomTo(INITIAL_SCALE, null, null, false);  // centre focal → centred zoom
//       }
// 
//       /* Re-clamp when a new image loads (its content box may differ) */
//       lbImg.addEventListener('load', function () {
//         if (isMobile() && !lightbox.hasAttribute('hidden')) resetView();
//       });
// 
//       /* Zoom toward a focal point (vx,vy in stage/element coords).
//          With origin 0 0 and transform p = p_e*s + t, the element point
//          under the focus is p_e = (focus - t)/s; we re-solve t so that
//          same p_e stays under the focus at the new scale. */
//       function zoomTo(newScale, vx, vy, animate) {
//         newScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
//         if (vx == null) { vx = stage.clientWidth / 2; vy = stage.clientHeight / 2; }
//         var ix = (vx - tx) / scale;
//         var iy = (vy - ty) / scale;
//         scale = newScale;
//         tx = vx - ix * scale;
//         ty = vy - iy * scale;
//         clamp();
//         apply(animate);
//       }
// 
//       /* ── Buttons ──────────────────────────────────────── */
//       if (zoomInBtn)  zoomInBtn.addEventListener('click', function () { zoomTo(scale * 1.5, null, null, true); });
//       if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { zoomTo(scale / 1.5, null, null, true); });
// 
//       if (fsBtn) {
//         fsBtn.addEventListener('click', function () {
//           var d = document;
//           var fsEl = d.fullscreenElement || d.webkitFullscreenElement;
//           if (fsEl) {
//             (d.exitFullscreen || d.webkitExitFullscreen || function () {}).call(d);
//           } else {
//             var req = lightbox.requestFullscreen || lightbox.webkitRequestFullscreen;
//             if (req) req.call(lightbox);
//           }
//         });
//         /* Re-fit after the fullscreen transition changes the viewport */
//         document.addEventListener('fullscreenchange', function () {
//           if (isMobile() && !lightbox.hasAttribute('hidden')) {
//             requestAnimationFrame(resetView);
//           }
//         });
//       }
// 
//       /* ── Touch gestures: drag-pan + pinch-zoom ────────── */
//       var pointers = {};            // active touch pointers by id
//       var startTx = 0, startTy = 0, startScale = 1;
//       var startDist = 0, startMidX = 0, startMidY = 0;
//       var panStartX = 0, panStartY = 0;
//       var lastTap = 0;
// 
//       function ptList() {
//         var a = []; for (var k in pointers) a.push(pointers[k]); return a;
//       }
//       function midAndDist(a, b) {
//         var dx = b.x - a.x, dy = b.y - a.y;
//         return {
//           mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2,
//           dist: Math.hypot(dx, dy)
//         };
//       }
// 
//       stage.addEventListener('pointerdown', function (e) {
//         if (!isMobile()) return;
//         pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
//         try { stage.setPointerCapture(e.pointerId); } catch (err) {}
//         var pts = ptList();
// 
//         if (pts.length === 1) {
//           stage.classList.add('is-panning');
//           panStartX = e.clientX; panStartY = e.clientY;
//           startTx = tx; startTy = ty;
//         } else if (pts.length === 2) {
//           var md = midAndDist(pts[0], pts[1]);
//           startDist = md.dist || 1;
//           var sr = stage.getBoundingClientRect();
//           startMidX = md.mx - sr.left;
//           startMidY = md.my - sr.top;
//           startScale = scale;
//           startTx = tx; startTy = ty;
//         }
//       });
// 
//       stage.addEventListener('pointermove', function (e) {
//         if (!isMobile() || !pointers[e.pointerId]) return;
//         pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
//         var pts = ptList();
// 
//         if (pts.length >= 2) {
//           /* Pinch: scale around the gesture midpoint */
//           var md = midAndDist(pts[0], pts[1]);
//           var sr = stage.getBoundingClientRect();
//           var ratio = (md.dist || 1) / startDist;
//           var ns = Math.max(MIN_SCALE, Math.min(MAX_SCALE, startScale * ratio));
//           var ix = (startMidX - startTx) / startScale;
//           var iy = (startMidY - startTy) / startScale;
//           scale = ns;
//           tx = startMidX - ix * scale;
//           ty = startMidY - iy * scale;
//           clamp();
//           apply(false);
//         } else if (pts.length === 1) {
//           /* One finger: pan only when zoomed past fit, else let the
//              tap/double-tap logic handle it (no drift). */
//           if (scale > 1.001) {
//             tx = startTx + (e.clientX - panStartX);
//             ty = startTy + (e.clientY - panStartY);
//             clamp();
//             apply(false);
//           }
//         }
//       });
// 
//       function onPointerEnd(e) {
//         if (!pointers[e.pointerId]) return;
//         delete pointers[e.pointerId];
//         if (ptList().length === 0) {
//           stage.classList.remove('is-panning');
//           /* Double-tap to toggle zoom (only when essentially un-moved) */
//           if (isMobile() && e.pointerType === 'touch') {
//             var now = e.timeStamp || 0;
//             var moved = Math.abs(e.clientX - panStartX) > 8 ||
//                         Math.abs(e.clientY - panStartY) > 8;
//             if (!moved && now - lastTap < 300) {
//               var sr = stage.getBoundingClientRect();
//               var fx = e.clientX - sr.left, fy = e.clientY - sr.top;
//               zoomTo(scale > 1.001 ? 1 : 2.5, fx, fy, true);
//               lastTap = 0;
//             } else if (!moved) {
//               lastTap = now;
//             }
//           }
//         }
//       }
//       stage.addEventListener('pointerup', onPointerEnd);
//       stage.addEventListener('pointercancel', onPointerEnd);
// 
//       /* Expose a hook so the open/show flow can (re)initialise the
//          viewer for the current screen size. */
//       lbMobileReset = function () {
//         if (isMobile()) {
//           if (controls) controls.setAttribute('aria-hidden', 'false');
//           /* Base transform is already fitted+centred via object-fit,
//              so this is valid even before the hi-res image decodes;
//              the load handler re-runs it once dimensions are known. */
//           resetView();
//         } else {
//           /* Desktop: drop any leftover transform from a narrow session
//              so the original lightbox styling applies cleanly. */
//           lbImg.style.transform = '';
//           lbImg.classList.remove('is-animating');
//           if (controls) controls.setAttribute('aria-hidden', 'true');
//         }
//       };
//     })();

    /* ══════════════════════════════════════════════════════
       DESCRIPTION TOGGLE
       ══════════════════════════════════════════════════════ */
    var descToggle  = $('[data-desc-toggle]', section);
    var descContent = $('[data-desc-content]', section);
    if (descToggle && descContent) {
      var descBlockEl = descToggle.closest('.product-description') || descContent;

      /* Only offer the toggle when the description is taller than 3 lines.
         Measure the natural (unclamped) height and compare it against a
         3-line threshold derived from the computed line-height — this is
         more reliable than scrollHeight/clientHeight under -webkit-line-clamp,
         where the clamped box can report the two as equal. If it fits in
         3 lines, show it in full and leave the button hidden. */
      var evaluateTruncation = function () {
        var wasCollapsed = descContent.classList.contains('is-collapsed');
        descContent.classList.remove('is-collapsed');

        /* Measure the real line-height of the text that actually renders.
           Rich-text descriptions wrap their copy in <p>/<li> whose line-height
           (1.7) differs from the container's (1.4). Shopify's editor sometimes
           also nests that copy inside extra <div> wrappers, so reading off the
           container — or even firstElementChild — can land on an element with
           the wrong line-height and flag true 3-line copy as overflowing.
           Query the first real text element anywhere inside the content. */
        var measureEl = descContent.querySelector('p, li') ||
          descContent.firstElementChild || descContent;
        var cs = getComputedStyle(measureEl);
        var lineHeight = parseFloat(cs.lineHeight);
        if (!lineHeight) {
          lineHeight = parseFloat(cs.fontSize) * 1.7;
        }
        /* Compare against the unclamped height with a half-line tolerance so
           sub-pixel rounding on exactly-3-line copy never trips the toggle. */
        var fullHeight = descContent.scrollHeight;
        var overflows = fullHeight > lineHeight * 3 + lineHeight * 0.5;

        descBlockEl.classList.toggle('is-truncatable', overflows);
        if (overflows && wasCollapsed) {
          descContent.classList.add('is-collapsed');
          descToggle.setAttribute('aria-expanded', 'false');
        } else {
          descToggle.setAttribute('aria-expanded', 'true');
        }
      };
      evaluateTruncation();
      window.addEventListener('resize', evaluateTruncation);

      descToggle.addEventListener('click', function () {
        var isCollapsed = descContent.classList.contains('is-collapsed');
        var willCollapse = !isCollapsed;
        descContent.classList.toggle('is-collapsed', willCollapse);
        descToggle.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
        var toggleLabel = descToggle.querySelector('[data-desc-toggle-label]') ||
          descToggle.querySelector('span');
        if (toggleLabel) {
          toggleLabel.textContent = isCollapsed
            ? (descToggle.dataset.lessText || 'Show Less')
            : (descToggle.dataset.moreText || 'Show More');
        }

        /* When collapsing, the page suddenly shrinks (max-height 2000→96px
           over 0.35s). The user's scroll position stays the same, so they
           end up scrolled past the description into an unrelated section.
           After the collapse animation finishes, scroll the description
           back into view — but only if the user is currently below it. */
        if (willCollapse) {
          var descBlock = descToggle.closest('.product-description') || descContent;
          var onEnd = function (e) {
            if (e.propertyName !== 'max-height') return;
            descContent.removeEventListener('transitionend', onEnd);
            var headerVar = parseFloat(
              getComputedStyle(document.documentElement).getPropertyValue('--header-height')
            ) || 100;
            var targetTop = descBlock.getBoundingClientRect().top + window.scrollY - headerVar - 12;
            if (window.scrollY > targetTop) {
              window.scrollTo({ top: targetTop, behavior: 'smooth' });
            }
          };
          descContent.addEventListener('transitionend', onEnd);
        }
      });
    }

    /* ══════════════════════════════════════════════════════
       SHARE BUTTON
       ══════════════════════════════════════════════════════ */
    var shareBtn    = $('[data-share-btn]', section);
    var shareCopied = $('[data-share-copied]', section);
    if (shareBtn) {
      var origLabel = ($('[data-share-label]', shareBtn) || {}).textContent || '';
      shareBtn.addEventListener('click', function () {
        var title = shareBtn.dataset.shareTitle || document.title;
        var url   = shareBtn.dataset.shareUrl   || window.location.href;
        var lbl   = $('[data-share-label]', shareBtn);
        function showCopied() {
          if (shareCopied) shareCopied.removeAttribute('hidden');
          if (lbl) lbl.textContent = 'Copied!';
          setTimeout(function () {
            if (shareCopied) shareCopied.setAttribute('hidden', '');
            if (lbl) lbl.textContent = origLabel;
          }, 2000);
        }
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(showCopied);
        }
      });
    }

    /* ══════════════════════════════════════════════════════
       FBT — Individual add + variant dropdown + Add All
       ══════════════════════════════════════════════════════ */
    var fbtSection = $('[data-fbt-section]', section);
    if (fbtSection) {
      var fbtItems = $$('[data-fbt-item]', fbtSection);

      fbtItems.forEach(function (item) {
        var vSelect   = $('[data-fbt-variant-select]', item);
        var priceSpan = $('.product-fbt__price', item);
        if (vSelect) {
          vSelect.addEventListener('change', function () {
            var opt = vSelect.options[vSelect.selectedIndex];
            item.dataset.variantId = opt.value;
            if (priceSpan && opt.dataset.price) {
              priceSpan.textContent = formatMoney(parseInt(opt.dataset.price, 10));
            }
          });
        }
      });

      fbtItems.forEach(function (item) {
        /* Per-item quantity stepper */
        var fbtQtyMinus = $('[data-fbt-qty-minus]', item);
        var fbtQtyPlus  = $('[data-fbt-qty-plus]', item);
        var fbtQtyInput = $('[data-fbt-qty-input]', item);
        if (fbtQtyInput) {
          if (fbtQtyMinus) fbtQtyMinus.addEventListener('click', function () {
            var v = parseInt(fbtQtyInput.value, 10) || 1;
            if (v > 1) fbtQtyInput.value = v - 1;
          });
          if (fbtQtyPlus) fbtQtyPlus.addEventListener('click', function () {
            var v = parseInt(fbtQtyInput.value, 10) || 1;
            fbtQtyInput.value = v + 1;
          });
        }

        var addBtn = $('[data-fbt-add]', item);
        if (!addBtn) return;
        addBtn.addEventListener('click', function () {
          addBtn.disabled = true;
          var vid = item.dataset.variantId;
          var qty = fbtQtyInput ? parseInt(fbtQtyInput.value, 10) || 1 : 1;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty })
          })
            .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw d; }); return r.json(); })
            .then(function () {
              addBtn.classList.add('is-success');
              openCart();
              setTimeout(function () { addBtn.classList.remove('is-success'); addBtn.disabled = false; }, 1200);
            })
            .catch(function () { addBtn.disabled = false; });
        });
      });

      var addAllBtn      = $('[data-fbt-add-all]', fbtSection);
      var addAllText     = $('[data-fbt-add-all-text]', fbtSection);
      var addAllOrigText = addAllText ? addAllText.textContent.trim() : 'Add All to Cart';
      if (addAllBtn && fbtItems.length) {
        addAllBtn.addEventListener('click', function () {
          addAllBtn.classList.add('is-loading'); addAllBtn.disabled = true;
          var items = [];
          fbtItems.forEach(function (item) {
            var v = item.dataset.variantId;
            var qInput = $('[data-fbt-qty-input]', item);
            var q = qInput ? parseInt(qInput.value, 10) || 1 : 1;
            if (v) items.push({ id: parseInt(v, 10), quantity: q });
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw d; });
            return r.json();
          })
          .then(function () {
            addAllBtn.classList.remove('is-loading'); addAllBtn.classList.add('is-success');
            if (addAllText) addAllText.textContent = 'Added!';
            openCart();
            setTimeout(function () {
              addAllBtn.classList.remove('is-success'); addAllBtn.disabled = false;
              if (addAllText) addAllText.textContent = addAllOrigText;
            }, 2000);
          }).catch(function (err) {
            addAllBtn.classList.remove('is-loading'); addAllBtn.disabled = false;
            if (addAllText) addAllText.textContent = 'Error \u2014 try again';
            setTimeout(function () { if (addAllText) addAllText.textContent = addAllOrigText; }, 2000);
            /* error already surfaced to user via button text */
          });
        });
      }
    }

    /* ══════════════════════════════════════════════════════
       STICKY ADD-TO-CART BAR
       ══════════════════════════════════════════════════════ */
    var stickyBar = $('[data-sticky-bar]', section);

    if (stickyBar) {
      var buyButtonsTarget = $('[data-atc-button]', section);
      var _stickyAtcHidden = true;
      var _stickyFooterVis = false;

      function updateStickyBar() {
        var show = !_stickyAtcHidden && !_stickyFooterVis;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      if (buyButtonsTarget) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { _stickyAtcHidden = e.isIntersecting; });
          updateStickyBar();
        }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
        obs.observe(buyButtonsTarget);
      }

      var footerEl = document.querySelector('.shopify-section-group-footer-group');
      if (footerEl) {
        var footerObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { _stickyFooterVis = e.isIntersecting; });
          updateStickyBar();
        }, { threshold: 0 });
        footerObs.observe(footerEl);
      }

      if (stickyAtcEl) {
        stickyAtcEl.addEventListener('click', function () {
          var realAtc = $('[data-atc-button]:not([disabled])', section);
          if (realAtc) realAtc.click();
        });
      }
    }

    /* ══════════════════════════════════════════════════════
       STICKY GALLERY → STICKY HEADER
       When the sticky gallery reaches the bottom of the product
       grid (gallery can scroll no further), add .sticky_header
       to the site header so it locks to the top of the viewport.
       Only runs on desktop (>810px); mobile uses theme.liquid logic.
       Controlled by enable_sticky_gallery schema toggle.
       ══════════════════════════════════════════════════════ */
    var stickyGalleryEl = $('.product-gallery--sticky', section);
    if (stickyGalleryEl) {
      var siteHeaderEl  = document.querySelector('.shopify-section-header');
      var productGrid   = $('.main-product__grid', section);

      if (siteHeaderEl && productGrid) {
        var sghRafPending = false;

        function checkGalleryAtBottom() {
          // Skip on mobile — theme.liquid handles sticky_header there
          if (window.innerWidth <= 810) {
            siteHeaderEl.classList.remove('sticky_header');
            return;
          }

          // Gallery sticky offset from top of viewport (CSS top value)
          var stickyOffset      = parseFloat(getComputedStyle(stickyGalleryEl).top) || 24;
          var galleryViewBottom = stickyOffset + stickyGalleryEl.offsetHeight;
          var gridViewBottom    = productGrid.getBoundingClientRect().bottom;

          // When the grid's bottom edge has scrolled up to the gallery's bottom edge,
          // the gallery has "touched" the grid bottom while sticking → show sticky header
          siteHeaderEl.classList.toggle('sticky_header', gridViewBottom <= galleryViewBottom);
        }

        window.addEventListener('scroll', function () {
          if (!sghRafPending) {
            sghRafPending = true;
            requestAnimationFrame(function () {
              checkGalleryAtBottom();
              sghRafPending = false;
            });
          }
        }, { passive: true });

        window.addEventListener('resize', function () {
          requestAnimationFrame(checkGalleryAtBottom);
        }, { passive: true });

        // Run once on load to set correct initial state
        checkGalleryAtBottom();
      }
    }

    /* ══════════════════════════════════════════════════════
       UTILITIES
       ══════════════════════════════════════════════════════ */
    function openCart() {
      var ct = document.documentElement.dataset.cartType
        || document.body.dataset.cartType
        || (document.getElementById('cart-drawer') ? 'drawer' : 'page');
      if (ct === 'page') { window.location.href = '/cart'; return; }
      /* Start the cart fetch AND open the drawer simultaneously — the fetch
         runs during the open animation (~300ms) so items are ready by the
         time it completes. No sequential delay. */
      window._cartFetchPromise = fetch('/cart.js').then(function (r) { return r.json(); });
      document.dispatchEvent(new CustomEvent('cart:open'));
    }

    function fetchCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartBadge(cart.item_count); })
        .catch(function () {});
    }

    function updateCartBadge(count) {
      var badges = document.querySelectorAll('.nav__cart-count, [data-cart-count]');
      if (badges.length === 0 && count > 0) {
        document.querySelectorAll('a.nav__cart, a[href="/cart"]').forEach(function (link) {
          var s = document.createElement('span');
          s.className = 'nav__cart-count'; s.setAttribute('aria-hidden', 'true');
          s.textContent = count; link.appendChild(s);
        });
        return;
      }
      badges.forEach(function (el) {
        if (count > 0) { el.textContent = count; el.style.display = ''; el.removeAttribute('hidden'); }
        else { el.textContent = ''; el.style.display = 'none'; }
      });
    }

  });
})();
